import { View, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { ThemedText } from "@/components/ThemedText";
import { useTheme } from "@/hooks/useTheme";
import { EntityType } from "../types";

interface EmptyStateProps {
  entityType: EntityType;
}

export function EmptyState({ entityType }: EmptyStateProps) {
  const { colors } = useTheme();

  return (
    <View style={[styles.container, { backgroundColor: colors.backgroundSecondary }]}>
      <MaterialCommunityIcons name="folder-open-outline" size={48} color={colors.textSecondary} />
      <ThemedText style={[styles.title, { color: colors.text }]}>No files yet</ThemedText>
      <ThemedText style={[styles.subtitle, { color: colors.textSecondary }]}>
        Upload files to this {entityType.replace("_", " ")}
      </ThemedText>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    padding: 32,
    borderRadius: 12,
    gap: 8,
    minHeight: 200,
  },
  title: {
    fontSize: 16,
    fontWeight: "600",
    marginTop: 8,
  },
  subtitle: {
    fontSize: 14,
    textAlign: "center",
  },
});
